import styled from '@emotion/styled';
import Alert, { AlertProps } from '@mui/material/Alert';

export const TermsOfUseChangedAlert = styled(Alert)<AlertProps>(() => {
  return {
    '& .MuiAlert-message': {
      padding: 0,
    },
    '& .MuiTypography-root': {
      margin: '8px',
    },
    '& .MuiAlert-icon': {
      fontSize: '32px',
    },
  };
});
